import Payment, { PaymentDto } from "../payment/Payment"

export type CreditMemoAttributesDto = {
    orderReferenceId: string,
    payment: PaymentDto,
    currency: string,
    remainingAmount: string,
    amount : string,
    refundedAmount : string,
    contactId: string,
    identifier : string,
    type : string,
    deletedBy : string,
    notes : string
}

export type CreditMemoDto = {
    id: string,
    type: string,
    attributes: CreditMemoAttributesDto
}

export default class CreditMemo {
    private dto: CreditMemoDto
    constructor(dto: CreditMemoDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "credit-memos"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): CreditMemoAttributesDto {
        return this.dto.attributes
    }

    getPayment(): Payment {
        return new Payment(this.dto.attributes.payment)
    }

    getCurrency(): string {
        return this.dto.attributes.currency
    }

    getRemainingAmount(): string {
        return this.dto.attributes.remainingAmount
    }

    getAmount() : string {
        return this.dto.attributes.amount
    }

    getRefundedAmount() : string {
        return this.dto.attributes.refundedAmount
    }

    getContactId(): string {
        return this.dto.attributes.contactId
    }

    getIdentifier() : string {
        return this.dto.attributes.identifier
    }

    getType() : string {
        return this.dto.attributes.type
    }

    getDeletedBy() : string {
        return this.dto.attributes.deletedBy
    }

    getNotes() : string {
        return this.dto.attributes.notes
    }
}


// WEBPACK FOOTER //
// ./src/state/credit-memo/CreditMemo.ts